// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoaderComp_card__Ap356 {
  background: transparent;
  border-radius: 0.15em;
  text-align: center;
  padding: 40px 32px;
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
}

.LoaderComp_loader__Ed2pe {
  position: relative;
  width: 2.5em;
  height: 2.5em;
  transform: rotate(165deg);
  margin-bottom: 30px;
}


.LoaderComp_loader__Ed2pe::before,
.LoaderComp_loader__Ed2pe::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 0.5em;
  height: 0.5em;
  border-radius: 0.25em;
  transform: translate(-50%, -50%);
}

.LoaderComp_loader__Ed2pe::before {
  animation: LoaderComp_before__JSGYu 2s infinite;
}
.LoaderComp_loader__Ed2pe::after {
  animation: LoaderComp_after__PQ3g1 2s infinite;
}

@keyframes LoaderComp_before__JSGYu {
  0% {
    width: 0.5em;
    box-shadow: 1em -0.75em #b45dbb, -1em 0.75em #4772ff;
  }
  35% {
    width: 2.5em;
    box-shadow: 0 -0.75em #b45dbb, 0 0.75em #4772ff;
  }
  70% {
    width: 0.5em;
    box-shadow: -1em -0.75em #b45dbb, 1em 0.75em #4772ff;
  }
  100% {
    box-shadow: 1em -0.75em #b45dbb, -1em 0.75em #4772ff;
  }
}

@keyframes LoaderComp_after__PQ3g1 {
  0% {
    height: 0.5em;
    box-shadow: 0.75em 1em #28c199bf, -0.75em -1em #f6b621bf;
  }
  35% {
    height: 2.5em;
    box-shadow: 0.75em 0 #28c199bf, -0.75em 0 #f6b621bf;
  }
  70% {
    height: 0.5em;
    box-shadow: 0.75em -1em #28c199bf, -0.75em 1em #f6b621bf;
  }
  100% {
    box-shadow: 0.75em 1em #28c199bf, -0.75em -1em #f6b621bf;
  }
}

.LoaderComp_loaderDots__KncZa {
  font-size: 1.2rem;
  font-weight: 500;
  color: #333;
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: center;
}

.LoaderComp_dot__At-tg {
  font-size: 1.5rem;
  color: #b45dbb;
}

.LoaderComp_blink1__gkvsp {
  animation: LoaderComp_blink__kpV-N 1.4s infinite;
  animation-delay: 0s;
}

.LoaderComp_blink2__zDe0W {
  animation: LoaderComp_blink__kpV-N 1.4s infinite;
  animation-delay: 0.2s;
}

.LoaderComp_blink3__FYqbL {
  animation: LoaderComp_blink__kpV-N 1.4s infinite;
  animation-delay: 0.4s;
}

@keyframes LoaderComp_blink__kpV-N {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/LoaderComp.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;;AAGA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,+CAA6B;AAC/B;AACA;EACE,8CAA4B;AAC9B;;AAEA;EACE;IACE,YAAY;IACZ,oDAAoD;EACtD;EACA;IACE,YAAY;IACZ,+CAA+C;EACjD;EACA;IACE,YAAY;IACZ,oDAAoD;EACtD;EACA;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,aAAa;IACb,wDAAwD;EAC1D;EACA;IACE,aAAa;IACb,mDAAmD;EACrD;EACA;IACE,aAAa;IACb,wDAAwD;EAC1D;EACA;IACE,wDAAwD;EAC1D;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gDAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gDAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gDAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".card {\n  background: transparent;\n  border-radius: 0.15em;\n  text-align: center;\n  padding: 40px 32px;\n  width: 320px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n}\n\n.loader {\n  position: relative;\n  width: 2.5em;\n  height: 2.5em;\n  transform: rotate(165deg);\n  margin-bottom: 30px;\n}\n\n\n.loader::before,\n.loader::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: block;\n  width: 0.5em;\n  height: 0.5em;\n  border-radius: 0.25em;\n  transform: translate(-50%, -50%);\n}\n\n.loader::before {\n  animation: before 2s infinite;\n}\n.loader::after {\n  animation: after 2s infinite;\n}\n\n@keyframes before {\n  0% {\n    width: 0.5em;\n    box-shadow: 1em -0.75em #b45dbb, -1em 0.75em #4772ff;\n  }\n  35% {\n    width: 2.5em;\n    box-shadow: 0 -0.75em #b45dbb, 0 0.75em #4772ff;\n  }\n  70% {\n    width: 0.5em;\n    box-shadow: -1em -0.75em #b45dbb, 1em 0.75em #4772ff;\n  }\n  100% {\n    box-shadow: 1em -0.75em #b45dbb, -1em 0.75em #4772ff;\n  }\n}\n\n@keyframes after {\n  0% {\n    height: 0.5em;\n    box-shadow: 0.75em 1em #28c199bf, -0.75em -1em #f6b621bf;\n  }\n  35% {\n    height: 2.5em;\n    box-shadow: 0.75em 0 #28c199bf, -0.75em 0 #f6b621bf;\n  }\n  70% {\n    height: 0.5em;\n    box-shadow: 0.75em -1em #28c199bf, -0.75em 1em #f6b621bf;\n  }\n  100% {\n    box-shadow: 0.75em 1em #28c199bf, -0.75em -1em #f6b621bf;\n  }\n}\n\n.loaderDots {\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: #333;\n  display: flex;\n  gap: 2px;\n  align-items: center;\n  justify-content: center;\n}\n\n.dot {\n  font-size: 1.5rem;\n  color: #b45dbb;\n}\n\n.blink1 {\n  animation: blink 1.4s infinite;\n  animation-delay: 0s;\n}\n\n.blink2 {\n  animation: blink 1.4s infinite;\n  animation-delay: 0.2s;\n}\n\n.blink3 {\n  animation: blink 1.4s infinite;\n  animation-delay: 0.4s;\n}\n\n@keyframes blink {\n  0%,\n  100% {\n    opacity: 0.2;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `LoaderComp_card__Ap356`,
	"loader": `LoaderComp_loader__Ed2pe`,
	"before": `LoaderComp_before__JSGYu`,
	"after": `LoaderComp_after__PQ3g1`,
	"loaderDots": `LoaderComp_loaderDots__KncZa`,
	"dot": `LoaderComp_dot__At-tg`,
	"blink1": `LoaderComp_blink1__gkvsp`,
	"blink": `LoaderComp_blink__kpV-N`,
	"blink2": `LoaderComp_blink2__zDe0W`,
	"blink3": `LoaderComp_blink3__FYqbL`
};
export default ___CSS_LOADER_EXPORT___;
